import * as React from "react";
import { useComponentsContext } from "./internal/provider.js";
import { MountPortal } from "./internal/mount-portal.js";
import { Skeleton } from "./internal/skeleton.js";
const AppLayoutManaged = React.forwardRef(({ content, ...rest }, ref) => {
    const components = useComponentsContext();
    return (React.createElement(MountPortal, { loader: (content) => React.createElement(Skeleton, { notifications: rest.notifications, content: content }), content: (components === null || components === void 0 ? void 0 : components.AppLayout) ? (content) => React.createElement(components.AppLayout, { ref: ref, ...rest, content: content }) : null }, content));
});
export default AppLayoutManaged;
